import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DocumentListEffects } from './document-list.effects';
import { initialState, reducer } from './document-list.reducer';
import { createWorkspaceScopedSyncReducer } from '../local-storage-sync';
import { DocumentListState } from './document-list.state';

const syncMetaReducer = createWorkspaceScopedSyncReducer<DocumentListState>({
  keys: ['searchFilter'],
  rehydrate: true,
  storage: localStorage,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('documentList', reducer, {
      initialState,
      metaReducers: [syncMetaReducer],
    }),
    EffectsModule.forFeature([DocumentListEffects]),
  ],
  providers: [DocumentListEffects],
})
export class DocumentListStoreModule {}
